import { LucidServerAPI, listParamsToString } from '~api/api';

export const getContainers = (filters = {}) => {
  return LucidServerAPI().get(`/containers?${listParamsToString(filters)}`);
};

